<template lang="pug">
  Icon.bookmark(:name="light && !active ? 'bookmarks' : 'bookmarks2'" :class="{ active }" pointer @click.native="toggle")
</template>

<script>
import userFavorites from '@/model/userFavorites';

export default {
  name: 'BaseBookmark',
  props: {
    category: String,
    id: String,
    light: Boolean,
  },
  computed: {
    active() {
      if (!this.category || !this.id) {
        return false;
      }

      return userFavorites.isFavorite(this.category, this.id);
    },
  },
  methods: {
    toggle() {
      userFavorites.toggleFavorite(this.category, this.id);
    },
  },
};
</script>

<style scoped lang="scss">
  .bookmark {
    display: block;
    width: 14px;
    height: 20px;
    fill: var(--color-super-light);
    transition: fill 0.2s;

    &.active {
      fill: var(--color-yellow);
    }
  }

</style>
